class Server {
  post(url, params) {
    return fetch(
      url,
      {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        credentials: 'same-origin'
      }
    );
  }

  broadcastEvent(params) {
    return this.post('/api/broadcast_ui_event', params);
  }
}

export default (new Server());